export default {
  unzugeordnet: 'unzugeordnet',
  abteilung: 'abteilung',
  abgelehnt: 'abgelehnt',
  freigegeben: 'freigegeben',
  archiv: 'archiv',
  papierkorb: 'papierkorb',
};
